import m from "../../geodata/es2015/nicaraguaHigh";
window.am4geodata_nicaraguaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/nicaraguaHigh.js
// module id = null
// module chunks = 